import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Endocrinology icon
 *
 * @category Medical
 */
const Endocrinology = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M20.34 9.88c-.6-1.56.39-4-1.68-4.69-1.08-.31-2.19.27-3.29.02-2.98-.68-3.37 1.37-3.32 3.91-.08.62-.28.96-.8 1.18-4.261 1.18-7.08 5.42-5.95 10.33.479 2.39 1.84 5.39 4.669 4.83.66-.03 1.32-.78 1.92-.72.23.13.31.63.45.92.68 1.64 2.13 1.47 3.77 1.48 2.18.11 3.51-.17 4-2.07.27-.78.95.03 1.46.18 1.04.44 2.11.42 2.98-.24 2.65-1.97 3.3-7.37 1.75-10.41-1.25-2.69-3.73-3.56-5.88-4.61l-.07-.1zm-6.59-3.62c.32-.19.69-.26 1.08-.23.79.07 1.54.17 2.33.09.47-.05 1-.12 1.39.16.46.32.51.97.52 1.53l.06 2.75c.02 1.11.05 2.23-.25 3.29s-.97 2.08-1.99 2.52-2.82-.21-3.37-1.29c.65.25 1.51.45 2.03.44.21 0 .48-.04.55-.24.09-.24-.17-.45-.4-.55-.45-.18-.94-.25-1.39-.41s-.92-.07-1.06-.54c-.04-.12-.02-.66.06-.76s.23-.12.36-.12c.74 0 1.48.41 2.18.17.12-.04.24-.11.28-.22.09-.22-.16-.43-.38-.52-.7-.3-2.03-.3-2.62-.77-.34-.27-.47-.65-.29-1.05.2-.42.42-.43.67-.42s.64.18.88.25c.61.18 1.56.32 2.19.32 1.34 0 1.67-.44 1.63-.6-.06-.22-.24-.42-.57-.32-.79.22-1.53.06-2.34-.06s-2.08-.33-2.34-1.11c-.15-.45.1-1.5.37-1.89.12-.18.27-.31.43-.42zM19 22.84c-1.33.96-3.55.92-5.14.38-.54-.18-1.09-.69-.48-1.18 1.13-1.09 5.65-1.07 5.69.7l-.06.1zm-.89 3.26h-3.97c-1.02-.05-1.23-1.25-.95-2.1 1.87.75 3.91.78 5.82 0 .13.02.08.41.09.71.07.62-.28 1.3-.9 1.39zm4.59-1.4c-1.55-.25-2.25-2.16-3.59-3.11-2.07-1.53-5.27-1.3-6.87.78-1.92 2.76-4 3.24-5.451 0-1.65-3.98-.45-8.83 2.98-10.7.64-.37 1.6-.52 1.98.15.45.73.44 1.89.77 2.72.4 1.27 1.43 2.33 2.75 2.64 2.22.55 3.98-1.26 4.55-3.62.24-.85.37-2.12 1.36-2.23 4.31.72 5.97 6.69 4.37 10.69-.45 1.18-1.3 2.71-2.69 2.7h-.15z"
        />
      </svg>
    );
  }
);

Endocrinology.displayName = 'Endocrinology';

export { Endocrinology };
